import http from '../../lib/http';

export const FETCH_BAR_REPORT_RECEIPTS_START = 'FETCH_BAR_REPORT_RECEIPTS_START';
export const FETCH_BAR_REPORT_RECEIPTS_ERROR = 'FETCH_BAR_REPORT_RECEIPTS_ERROR';
export const FETCH_BAR_REPORT_RECEIPTS_SUCCESS = 'FETCH_BAR_REPORT_RECEIPTS_SUCCESS';

export const CLEAR_BAR_REPORT_RECEIPTS = 'CLEAR_BAR_REPORT_RECEIPTS';

export function clearBarReportReceipts() {
    return {
        type: CLEAR_BAR_REPORT_RECEIPTS
    }
}

export function fetchBarReportReceipts(barId, limit, page, vats) {
    return {
        type: 'FETCH_BAR_REPORT_RECEIPTS',
        payload: {
            vats: vats,
            promise: getBarReportReceipts(barId, limit, page)
        }
    };
}

async function getBarReportReceipts(barId, limit, page) {
    const res = await http.get(`/app/bar/receipt/${barId}/${limit}/${page}`);
    if (res.status < 300) return res.json();
    throw res;
}



// WEBPACK FOOTER //
// ./src/common/report/receipt/actions.js